"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaltAnchors = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];
var isAnchor = function (text) {
    return typeof text === 'string' && defaltAnchors.includes(text);
};
var VieWithGoogleControl = /** @class */ (function () {
    function VieWithGoogleControl(options) {
        if (options === void 0) { options = {}; }
        this._container = document.createElement("div");
        this._container.style.display = "flex";
        this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group geolonia-ctrl-view-with-google";
        this._container.style.padding = ".3em 1em .2em";
        var lang = options.lang || 'ja';
        var lng = options.lng, lat = options.lat;
        var url = "https://www.google.com/maps/@" + lat + "," + lng + "?q=" + lat + "," + lng;
        var texts = {
            'ja': 'Google Maps で見る',
            'en': 'View with Google Maps',
        };
        this._container.innerHTML = "<a href=\"" + url + "\">" + (texts[lang] || texts.ja) + "</a>";
    }
    VieWithGoogleControl.prototype.onAdd = function (map) {
        return this._container;
    };
    VieWithGoogleControl.prototype.onRemove = function () {
        if (this._container && this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
        }
    };
    return VieWithGoogleControl;
}());
var ViewWithGoogleGeoloniaPlugin = function (map, target, atts) {
    var anchor = isAnchor(atts.anchor) ? atts.anchor : defaltAnchors[0];
    var lng = parseFloat(atts.lng);
    var lat = parseFloat(atts.lat);
    if (!Number.isNaN(lng) && !Number.isNaN(lat)) {
        map.addControl(new VieWithGoogleControl({
            lang: atts.lang,
            lng: lng,
            lat: lat,
        }), anchor);
    }
};
window.geolonia.registerPlugin(ViewWithGoogleGeoloniaPlugin);
